"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const react_1 = __importStar(require("react"));
const components_1 = require("@/components");
const toast_1 = require("@/components/toast");
const constants_1 = __importStar(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
// @ts-ignore
const styles_ts_1 = __importDefault(require("./styles.ts"));
// TODO: improve this using polling.
const STRIPE_WEBHOOK_UPDATE_TIMEOUT = 3000;
const StripePaymentForm = ({ price, clientSecret, email, onSuccess, onError, }) => {
    const [disabled, setDisabled] = react_1.useState(true);
    const [processing, setProcessing] = react_1.useState(false);
    const stripe = react_stripe_js_1.useStripe();
    const elements = react_stripe_js_1.useElements();
    const handleChangeCard = (event) => __awaiter(void 0, void 0, void 0, function* () {
        setDisabled(!event.complete);
    });
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setProcessing(true);
        const payload = yield stripe.confirmCardPayment(clientSecret, {
            receipt_email: email,
            payment_method: {
                card: elements.getElement(react_stripe_js_1.CardElement),
            },
        });
        if (payload.error) {
            toast_1.showToast('Error', payload.error.message);
            setProcessing(false);
            onError();
        }
        else {
            setTimeout(() => {
                setProcessing(false);
                onSuccess();
            }, STRIPE_WEBHOOK_UPDATE_TIMEOUT);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        processing && (react_1.default.createElement(components_1.SaveLoader, { title: constants_1.default.paywall.payment.processingPayment, description: constants_1.default.general.pleaseDontClose })),
        react_1.default.createElement("form", { className: styles_scss_1.default.paymentForm, id: "payment-form" },
            react_1.default.createElement("div", { className: styles_scss_1.default.formLeftCont },
                react_1.default.createElement(react_stripe_js_1.CardElement, { id: "card-element", options: styles_ts_1.default.cardStyle, onChange: handleChangeCard, className: styles_scss_1.default.cardInput }),
                react_1.default.createElement("div", { className: styles_scss_1.default.buttons },
                    react_1.default.createElement(components_1.Button, { title: `Pay $${price}`, ariaLabel: `Pay $${price}`, className: styles_scss_1.default.submitButton, disabled: disabled || processing, onClick: handleSubmit })),
                react_1.default.createElement("small", { className: styles_scss_1.default.secureText },
                    react_1.default.createElement("img", { className: styles_scss_1.default.lockImg, src: constants_1.Images.lock, alt: "lock" }),
                    " ",
                    constants_1.default.paywall.payment.paymentsAreSecured)),
            react_1.default.createElement("div", { className: styles_scss_1.default.formRightCont }))));
};
exports.default = StripePaymentForm;
